import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { SurveyService } from "src/app/core/services/survey.service";
import { OOVenueService } from "src/app/core/services/venue-service";

@Component({
	selector: "app-customer-survey",
	templateUrl: "./customer-survey.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class CustomerSurveyComponent implements OnInit, OnDestroy {
	activatedTabPanelIndex: number = 0;

	surveyResponsesLoaded: boolean = false;
	surveyResponseSubscription: Subscription;

	surveyListLoaded: boolean = false;
	surveySubscription: Subscription;

	constructor(public app: AppService, public venueService: OOVenueService, public surveyService: SurveyService, private activatedRoute: ActivatedRoute) {}

	ngOnDestroy(): void {
		this.surveyResponseSubscription.unsubscribe();
		this.surveySubscription.unsubscribe();
	}

	ngOnInit(): void {
		if (
			!(
				this.activatedRoute.snapshot.queryParamMap.get("source")?.includes("RESPONSE") ||
				this.activatedRoute.snapshot.queryParamMap.get("source")?.includes("SURVEY")
			) &&
			this.surveyService.surveyList.value &&
			this.surveyService.surveyResponseList.value
		) {
			this.surveyService.surveyGetAll();
			this.surveyService.surveyResponseGetAll();
		} else {
			if (this.activatedRoute.snapshot.queryParamMap.get("source")?.includes("RESPONSE")) {
				this.activatedTabPanelIndex = 0;
			}
			if (this.activatedRoute.snapshot.queryParamMap.get("source")?.includes("SURVEY")) {
				this.activatedTabPanelIndex = 1;
			}
			this.surveyListLoaded = true;
			this.surveyResponsesLoaded = true;
		}

		this.surveyResponseSubscription = this.surveyService.surveyResponse.subscribe((surveyResponse) => {
			this.surveyResponsesLoaded = true;
		});
		this.surveySubscription = this.surveyService.surveyList.subscribe((survey) => {
			this.surveyListLoaded = true;
		});
	}
}
